import { actionCreatorFactory } from 'typescript-fsa/lib';
import { Idol } from './idols.reducer';
import { NewIdol } from '../../../modules/IdolCreate/index';
const actionCreator = actionCreatorFactory('Idol');

export const updateIdolEntities = actionCreator<{
  idols: {
    [key: number]: Idol;
  };
}>('ENTITIES_UPDATE');

export const fetchIdols = actionCreator('FETCH_IDOLS');

export const saveIdol = actionCreator<{ idol: NewIdol }>('SAVE_IDOL');



// WEBPACK FOOTER //
// ./src/store/Entities/Idols/idols.actions.ts